import React from 'react';
import {
	Elements, StripeProvider
} from 'react-stripe-elements';

import Form from './Form';

const BrowserPay = (props) => (
	<StripeProvider apiKey={props.stripePublicKey}>
		<Elements>
			<Form {...props} />
		</Elements>
	</StripeProvider>
);

export default BrowserPay
